import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui';

const Error404 = () => {
  const navigate = useNavigate();
  return (
    <div className="tw-flex tw-min-h-[70vh] tw-flex-col tw-items-center tw-justify-center tw-text-center">
      <div className="tw-mb-4 tw-text-[5rem] tw-font-extrabold tw-leading-none tw-text-heading">404</div>
      <h1 className="tw-text-xl tw-font-bold tw-text-heading">Page not found</h1>
      <p className="tw-mt-2 tw-max-w-sm tw-text-content-muted">
        The address may be mistyped, or the page has moved.
      </p>
      <Button className="tw-mt-6" icon="fa-house" onClick={() => navigate('/stream-dashboard')}>
        Back to Dashboard
      </Button>
    </div>
  );
};

export default Error404;
